<template>
  <tbody>
    <tr v-for="(row, rowIndex) in data" :key="rowIndex" :role="rowRole(row)" @click="doClick(row)">
      <table-data v-for="(column, columnIndex) in columns" :key="columnIndex" :setStyle="setStyle[columnIndex]" :value="row[column]" :badge-status="row[column + '.badge']" :selectable-rows="selectableRows" />
    </tr>
  </tbody>
</template>

<script>
import TableData from '@/views/atoms/table/TableData';
export default {
  name: "TableBody",
  components: {
    TableData,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    setStyle: {
      type: Array,
      required: false,
    },
    selectableRows: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['select'],
  methods: {
    canSelect(row) {
      // プロパティとしてidがない場合は選択できない
      return this.selectableRows && row.id !== undefined;
    },
    rowRole(row) {
      return this.canSelect(row) ? 'button' : '';
    },
    doClick(row) {
      if (this.canSelect(row)) {
        this.$emit('select', row.id);
      }
    },
  },
}
</script>
